import React from "react";
var __jsx = React.createElement;
import { useController } from "react-hook-form";
import stl from "./CustomInput.module.css";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
function CustomInputHookForm(_ref) {
  var _field$value, _field$value2;
  var name = _ref.name,
    control = _ref.control,
    rules = _ref.rules,
    label = _ref.label,
    className = _ref.className,
    currency = _ref.currency,
    referralMsg = _ref.referralMsg,
    type = _ref.type,
    placeholder = _ref.placeholder,
    maxLength = _ref.maxLength,
    onPaste = _ref.onPaste,
    onKeyDown = _ref.onKeyDown,
    onKeyUp = _ref.onKeyUp,
    onValueChange = _ref.onValueChange,
    options = _ref.options,
    hasButton = _ref.hasButton,
    buttonText = _ref.buttonText,
    buttonFunction = _ref.buttonFunction,
    resetCode = _ref.resetCode,
    isValid = _ref.isValid,
    ErrorInCode = _ref.ErrorInCode,
    ErrorMsg = _ref.ErrorMsg,
    id = _ref.id,
    buttonId = _ref.buttonId,
    errorId = _ref.errorId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useController = useController({
      name: name,
      control: control,
      rules: rules
    }),
    field = _useController.field,
    error = _useController.fieldState.error;
  var externalError = ErrorInCode ? ErrorMsg : undefined;
  var displayError = externalError || (error === null || error === void 0 ? void 0 : error.message);
  return /*#__PURE__*/React.createElement("div", {
    className: stl.parentContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.container, className, isValid ? stl.isValid : undefined, ErrorInCode ? stl.ErrorInCode : undefined, displayError ? stl.borderErr : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("label", null, label), type === "select" ? /*#__PURE__*/React.createElement("select", {
    id: id,
    name: field.name,
    ref: field.ref,
    value: (_field$value = field.value) !== null && _field$value !== void 0 ? _field$value : "",
    onBlur: field.onBlur,
    onChange: function onChange(e) {
      field.onChange(e.target.value);
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(e.target.value);
    }
  }, !(options !== null && options !== void 0 && options.length) && /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true
  }, t("select", {
    ns: "web_common"
  })), options === null || options === void 0 ? void 0 : options.map(function (opt, idx) {
    return /*#__PURE__*/React.createElement("option", {
      value: opt.id,
      key: idx + "opt"
    }, opt.name);
  })) : /*#__PURE__*/React.createElement("input", {
    id: id,
    name: field.name,
    ref: field.ref,
    type: type,
    placeholder: placeholder,
    value: (_field$value2 = field.value) !== null && _field$value2 !== void 0 ? _field$value2 : "",
    autoComplete: "off",
    maxLength: maxLength,
    onPaste: onPaste,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onBlur: field.onBlur,
    onChange: function onChange(e) {
      field.onChange(e.target.value);
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(e.target.value);
    }
  }), hasButton && /*#__PURE__*/React.createElement("span", {
    id: buttonId,
    onClick: !isValid ? buttonFunction : resetCode,
    className: stl.innerBtn
  }, ErrorInCode ? ErrorMsg : !isValid ? buttonText : t("remove_discount", {
    ns: "web_checkout_cash"
  })), currency && /*#__PURE__*/React.createElement("span", {
    className: stl.curn
  }, currency)), !ErrorInCode && displayError && /*#__PURE__*/React.createElement("div", {
    id: errorId,
    className: [stl.hasError, stl.err].join(" ")
  }, displayError), isValid && referralMsg && /*#__PURE__*/React.createElement("div", {
    className: stl.dicountShapeContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/post_check_mark.svg",
    alt: "discount"
  }), /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: referralMsg
    }
  })));
}
export default CustomInputHookForm;